export const stroke = {
  error: 1.5,
  focus: 2,
  icon: 1.5,
  lg: 2,
  md: 1,
  none: 0,
  selected: 1.5,
  sm: 0.5,
  xl: 4,
  nav: {
    "active-indicator": 4,
  },
  timeline: {
    indicator: 2,
  },
  "selection-control": {
    default: 1.5,
  },
} as const;

export type Stroke = typeof stroke;
